var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFindparking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0008 7.14258H8.57227V9.9997H10.0008C10.7884 9.9997 11.4294 9.35864 11.4294 8.57112C11.4294 7.7836 10.7884 7.14258 10.0008 7.14258Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5714 0H1.42858C0.639669 0 0 0.639669 0 1.42858V18.5714C0 19.3603 0.639669 20 1.42858 20H18.5714C19.3603 20 20 19.3603 20 18.5714V1.42858C20 0.639669 19.3603 0 18.5714 0V0ZM10 12.8571H8.57142V15.7142H5.71429V4.28571H10C12.3633 4.28571 14.2857 6.20812 14.2857 8.57142C14.2857 10.9347 12.3633 12.8571 10 12.8571Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindparking);
export default __webpack_public_path__ + "static/media/findparking.31db52a66c685fd662fd289b98a56859.svg";
export { ForwardRef as ReactComponent };